<div class="content">
  <form [formGroup]="AcdForm">
    <div id="input1" class="cardUiForm">
      <div class="acd-form-row">
        <div class="fields g-30">
          <div class="first-form-element">
            <h4 class="form-label">
              Facility <span class="mandatory">*</span>
            </h4>

            <div class="form-field mr-20">
              <kendo-dropdownlist
                [defaultItem]="commonservice.defaultDropdownItem"
                [data]="facilityListDD"
                textField="label"
                valueField="id"
                class="facilityDropdown"
                [(ngModel)]="selectedFacilityId"
                formControlName="facilityId"
                [valuePrimitive]="true"
              >
              </kendo-dropdownlist>

              <kendo-formerror
                *ngIf="(this.AcdForm.controls['facilityId'].touched || this.AcdForm.controls['facilityId'].dirty) && (this.AcdForm.controls['facilityId'].errors?.['required'] || this.AcdForm.controls['facilityId'].errors?.['min'])"
              >
                Required field
              </kendo-formerror>
            </div>
          </div>
          <div class="second-form-element">
            <h4 class="form-label">
              Priority <span class="mandatory">*</span>
            </h4>

            <div class="form-field">
              <kendo-dropdownlist
                *ngIf="showPriorityValue"
                [defaultItem]="commonservice.defaultDropdownItem"
                [data]="priorityListDD"
                textField="label"
                valueField="id"
                [(ngModel)]="selectedPriorityId"
                class="facilityDropdown"
                formControlName="priority"
                [valuePrimitive]="true"
              >
              </kendo-dropdownlist>

              <kendo-label *ngIf="!showPriorityValue" class="LableName">
                {{ AcdForm.get("priority")?.value }}
              </kendo-label>

              <kendo-formerror
                *ngIf="(this.AcdForm.controls['priority'].touched || this.AcdForm.controls['priority'].dirty) && (this.AcdForm.controls['priority'].errors?.['required'] || this.AcdForm.controls['priority'].errors?.['min'])"
              >
                Required field
              </kendo-formerror>
            </div>
          </div>
        </div>
      </div>

      <div class="acd-form-row">
        <div class="fields g-30">
          <div class="first-form-element">
            <h4 class="form-label">On behalf of</h4>

            <div class="form-field mr-20" #formField>
              <kendo-autocomplete
                [data]="userList"
                class="autocomplete"
                [placeholder]="userName ?? ''"
                valueField="name"
                id="OnBehalfOf"
                [kendoDropDownFilter]="{ operator: 'contains' }"
                [value]="selectedUser"
                (valueChange)="onUserValueChange($event)"
                formControlName="onBehalfOf"
                #autoComplete
                (dblclick)="onDoubleClick(autoComplete)"
              >
              </kendo-autocomplete>
            </div>
          </div>
          <div class="second-form-element">
            <h4 class="form-label">Requested By</h4>

            <div class="form-field">
              <kendo-label>{{ userName }}</kendo-label>
            </div>
          </div>
        </div>
      </div>

      <div class="acd-form-row">
        <div class="fields g-30">
          <div class="first-form-element">
            <h4 class="form-label">FERR / MoC</h4>

            <div class="form-field mr-20">
              <kendo-textbox
                placeholder="Please enter FERR or MoC "
                [clearButton]="true"
                class="textarea"
                formControlName="ferrMoc"
              ></kendo-textbox>
            </div>
          </div>
          <div class="second-form-element">
            <h4 class="form-label">MOC Due Date</h4>

            <div class="form-field">
              <kendo-datepicker
                calendarType="classic"
                formControlName="mocDueDate"
                [format]="format"
                placeholder=""
              ></kendo-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="acd-form-row" *ngIf="crNo > 0">
        <div class="fields g-15">
          <h4 class="form-bigLabel">Created Date</h4>

          <div class="form-bigField">
            <kendo-label *ngIf="crNo > 0" class="LableName">
              {{ AcdForm.get("createdDate")?.value | date : "dd-MM-yyyy" }}
            </kendo-label>
          </div>
        </div>
      </div>

      <div class="acd-form-row" *ngIf="showSubmitDate">
        <div class="fields g-30">
          <div class="first-form-element">
            <h4 class="form-label">Submission Date</h4>

            <div class="form-field mr-20">
              <kendo-label *ngIf="crNo > 0" class="LableName">
                {{ AcdForm.get("submitDate")?.value | date : "dd-MM-yyyy" }}
              </kendo-label>
            </div>
          </div>
          <div class="second-form-element">
            <h4 class="form-label">Due Date</h4>

            <div class="form-field">
              <kendo-label *ngIf="crNo > 0" class="LableName">
                {{ AcdForm.get("dueDate")?.value | date : "dd-MM-yyyy" }}
              </kendo-label>
            </div>
          </div>
        </div>
      </div>

      <div class="acd-form-row mt-10 mb-20">
        <div class="fields g-15">
          <h4 class="form-bigLabel">
            Description <span class="mandatory">*</span>
          </h4>

          <div class="form-bigField">
            <kendo-textarea
            class="desc"
              placeholder="Please include change description"
              value="AcdForm.description"
              [rows]="2"
              resizable="none"
              formControlName="description"
              class="w-100"
              [maxlength]="100"
            ></kendo-textarea>

            <kendo-formerror
              *ngIf="(this.AcdForm.controls['description'].touched || this.AcdForm.controls['description'].dirty) && (this.AcdForm.controls['description'].errors?.['required'] || this.AcdForm.controls['description'].errors?.['min'])"
            >
              Required field
            </kendo-formerror>
          </div>
        </div>
      </div>

      <div class="acd-form-row mb-20">
        <div class="fields g-15">
          <h4 class="form-bigLabel">Justification</h4>

          <div class="form-bigField">
            <kendo-textarea
              class="just"
              placeholder="Please specify brief justification for change"
              [rows]="5"
              resizable="vertical"
              formControlName="justification"
              [maxlength]="1000"
            ></kendo-textarea>
          </div>
        </div>
      </div>

      <div class="acd-form-row mb-20">
        <div class="fields g-15">
          <h4 class="form-bigLabel">Attachments</h4>

          <div class="form-bigField" *ngIf="isUserCanAccessRequest">
            <app-file-upload
              class="fileUpload"
              [elementId]="'AcdFile-upload'"
              [labelCSS]="'browseBtn'"
              [mainButtonCSS]="'custom-btn'"
              (fileUploaded)="saveAttachment($event)"
              [multipleAllowed]="true"
            >
            </app-file-upload>
          </div>
        </div>
      </div>

      <div class="acd-form-row mb-20" *ngIf="fileAttachmentDetails.length > 0">
        <div class="fields g-15">
          <h4 class="form-bigLabel"></h4>

          <div class="form-bigField" id="nonStyleGrid">
            <kendo-grid
              class="mt-10"
              [data]="fileAttachmentDetails"
              [scrollable]="'none'"
            >
              <kendo-grid-column title="">
                <ng-template kendoGridCellTemplate let-dataitem>
                  <div *ngIf="isUserCanAccessRequest" (click)="deleteFileAttachment(dataitem)">
                    <fa-icon [icon]="faclose" class="file-closeIcon"></fa-icon>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="File Name" field="fileName">
                <ng-template kendoGridCellTemplate let-dataitem>
                  <span
                    classs="noTextTranform"
                    style="text-transform: none !important"
                    >{{ dataitem.fileName  }}</span
                  >
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="File Size" field="fileSize">
                <ng-template kendoGridCellTemplate let-dataitem>
                  {{ formatFileSize(dataitem.fileSize) }}
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>

      <div class="instructions">
        Raise a&nbsp;<a href="https://ferr.chevron.com/" target="_blank">FERR</a
        >&nbsp;if your changes are one of the following:
        <div class="instructions-list">
          <div class="list">
            <ul>
              <li>New, Missing or Dispose Tags</li>
              <li>Challenges to IC or EC Ranking</li>
              <li>New PM Schedules</li>
              <li>Delete PM Schedules</li>
            </ul>
          </div>
          <div class="list">
            <ul>
              <li>Multiple PM changes</li>
              <li>Strategy Changes</li>
              <li>Association / Suppression Changes</li>
              <li>Challenges to OPS / GMS</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="FormButtons">
        <button [disabled]="!isUserCanAccessRequest" (click)="router.navigate(['/'])">Cancel</button>
        <button [disabled]="!isUserCanAccessRequest" (click)="Clear(); $event.preventDefault()">Clear</button>
        <button [disabled]="!isUserCanAccessRequest" type="submit" (click)="saveRequest(true)">Submit ACD</button>
        <button [disabled]="!isUserCanAccessRequest" class="btn4" (click)="saveRequest()">
          Save and go to search
        </button>
        </div>
      </div>
  </form>
</div>
